













































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { ITag, TagCategory } from 'admiral-core';
import { TagApi } from '@/services/TagApi';
import { TagIcon, CheckIcon, XIcon } from 'vue-feather-icons';

@Component({
  name: 'TaskTagFilter',
  components: {
    TagIcon,
    CheckIcon,
    XIcon,
  },
})
export default class TaskTagFilter extends mixins(BaseMixin) {
  @Prop({ type: Array, default: () => [] })
  selectedTags!: ITag[];

  TagCategory = TagCategory;
  taskTags: ITag[] = [];
  hovered = false;

  get displayLabel(): string {
    if (this.selectedTags.length === 0) return 'Alle Tags';
    if (this.selectedTags.length === 1) return this.selectedTags[0].name;
    return `${this.selectedTags[0].name} + ${this.selectedTags.length - 1}`;
  }

  isSelected(tag: ITag): boolean {
    return this.selectedTags.some((t) => t.id === tag.id);
  }

  toggleTag(tag: ITag) {
    const isSelected = this.isSelected(tag);
    const newTags = isSelected
      ? this.selectedTags.filter((t) => t.id !== tag.id)
      : [...this.selectedTags, tag];
    this.$emit('update:tags', newTags);
  }

  clearFilter() {
    this.$emit('update:tags', []);
  }

  async mounted() {
    try {
      const response = await TagApi.getTags({
        agency: this.user.agency,
        category: TagCategory.Tasks,
      });
      this.taskTags = response.data || [];
    } catch {
      this.taskTags = [];
    }
  }
}
